import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload_redesign",
  "use": "upload_redesign-usage",
  "viewBox": "0 0 35 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 35 34\" id=\"upload_redesign\"><path fill=\"#8390FF\" d=\"m17 26-8-8.322 1.82-1.894 4.893 5.089V0h2.574v20.873l4.892-5.09L25 17.679 17 26Z\" /><path fill=\"#8390FF\" d=\"M31.387 20.767v9.243c0 .733-.596 1.33-1.33 1.33H3.99c-.733 0-1.33-.597-1.33-1.33v-9.243H0v9.243C0 32.21 1.79 34 3.99 34h26.067c2.2 0 3.99-1.79 3.99-3.99v-9.243h-2.66Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol